module.exports = __webpack_public_path__ + "static/media/App icon Logger.8e69a6b3.png";